module.exports = __webpack_public_path__ + "static/media/photo5.d9d0b196.jpg";